import { faStreetView } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { CONTENT_TYPE } from "../constants";
import { Audio, Image360, ImageU, LinkU, Model3d, PDFU, VideoU } from "../icons";

export default function renderTypeIcon(type, props) {
  const dataTestId = `content-type-${type.toLowerCase().split(" ").join("-")}-icon`;
  const { color, ...iconProps } = props;
  switch (type) {
    case CONTENT_TYPE.THREE_HUNDRED_SIXTY_PHOTO:
      return <Image360 data-testid={dataTestId} {...props} />;
    case CONTENT_TYPE.THREE_DIMENSIONAL_MODEL:
      return <Model3d data-testid={dataTestId} {...props} />;
    case CONTENT_TYPE.VIRTUAL_TOUR:
      return <FontAwesomeIcon data-testid={dataTestId} color={color} icon={faStreetView} {...iconProps} />;
    case CONTENT_TYPE.VIDEO:
      return <VideoU data-testid={dataTestId} {...props} />;
    case CONTENT_TYPE.PHOTO:
      return <ImageU data-testid={dataTestId} {...props} />;
    case CONTENT_TYPE.PDF:
      return <PDFU data-testid={dataTestId} {...props} />;
    case CONTENT_TYPE.AUDIO:
      return <Audio data-testid={dataTestId} {...props} />;
    case CONTENT_TYPE.LINK:
      return <LinkU data-testid={dataTestId} {...props} />;
    default:
      return null;
  }
}
